const apiConfig = {
	baseUrl: import.meta.env.VITE_API_URL,
};

export default apiConfig;
